(() => {
  let requestNumber = 0;
  document.addEventListener('change', async event => {
    const select = event.target.closest('[data-piltron-shade-product]');
    if (!select) return;
    const root = select.closest('[data-product-section-id]');
    if (!root || !/^[a-z0-9-]+$/.test(select.value)) return;
    const current = ++requestNumber;
    const locale = (document.documentElement.lang || 'ar').slice(0, 2);
    const words = {ar:['جارٍ تحميل اللون…','تعذر تحميل اللون. حاول مرة أخرى.'],en:['Loading shade…','Unable to load this shade. Please try again.'],de:['Farbe wird geladen…','Die Farbe konnte nicht geladen werden. Bitte erneut versuchen.']}[locale] || ['Loading shade…','Unable to load this shade.'];
    const status = root.querySelector('[data-piltron-shade-status]');
    const oldSelection = select.querySelector('option[selected]')?.value;
    const quantity = root.querySelector('[data-piltron-quantity]')?.value;
    const buttons = [...root.querySelectorAll('button[type="submit"],input[type="submit"]')];
    const previousDisabled = buttons.map(button => button.disabled);
    buttons.forEach(button => button.disabled = true);
    select.disabled = true;
    root.setAttribute('aria-busy', 'true');
    if (status) status.textContent = words[0];
    const route = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/products/' + select.value;
    const url = new URL(route, location.origin);
    const fetchUrl = new URL(url); fetchUrl.searchParams.set('section_id', root.dataset.productSectionId);
    try {
      const response = await fetch(fetchUrl, {credentials:'same-origin'});
      if (!response.ok) throw new Error('section fetch failed');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = documentFragment.querySelector('[data-product-section-id]');
      if (!next || !next.querySelector('[data-piltron-single-form]')) throw new Error('missing product form');
      if (current !== requestNumber) return;
      next.removeAttribute('data-piltron-product-initialized');
      if (quantity) { const input = next.querySelector('[data-piltron-quantity]'); if(input) input.value = quantity; }
      root.replaceWith(next);
      document.dispatchEvent(new CustomEvent('piltron:product:replace', {detail:{root:next}}));
      window.PILTRONPricingUI?.scan(next);
      history.replaceState({}, '', url);
      document.title = next.querySelector('.piltron-names__primary')?.textContent?.trim() || document.title;
      next.querySelector('[data-piltron-shade-product]')?.focus({preventScroll:true});
    } catch(error) {
      if(current !== requestNumber) return;
      if(oldSelection) select.value = oldSelection;
      buttons.forEach((button,index) => button.disabled = previousDisabled[index]);
      if(status) status.textContent = words[1];
    } finally {
      if(root.isConnected) {select.disabled = false; root.removeAttribute('aria-busy');}
    }
  });
})();